export default __webpack_public_path__ + "static/media/crowdprocess.a60d768e.svg";